(function ($) {
	class W4D_AvailabilityNotify {
		constructor() {
			this.originalHtml = '';
			this.bindEvents();
		}

		bindEvents() {
			document.body.addEventListener(
				'command',
				(e) => {
					this.dialog = e.target;
					if (this.dialog.id === 'availability-notify') {
						if (!this.originalHtml) {
							this.originalHtml = this.dialog.innerHTML;
						}

						this.restoreOriginalState();
						this.handleAvailabilityCommand(e);
					}
				},
				{ capture: true }
			);

			document.body.addEventListener('modal-closed', (e) => {
				if (e.target.id === 'availability-notify') {
					this.restoreOriginalState();
				}
			});
		}

		restoreOriginalState() {
			if (this.originalHtml && this.dialog && this.dialog.innerHTML !== this.originalHtml) {
				this.dialog.innerHTML = this.originalHtml;
				this.form = this.dialog.querySelector('form');
			}
		}

		handleAvailabilityCommand(e) {
			const invoker = e.source;
			this.form = this.dialog.querySelector('form');
			this.productId = invoker.getAttribute('data-product-id') || '';
			this.variationId = invoker.getAttribute('data-variation-id') || '';
			this.initFormValidation();
		}

		initFormValidation() {
			$(this.form).validate({
				submitHandler: (form) => {
					this.handleSubmit(form);
				},
			});
		}

		handleSubmit(form) {
			const fd = new FormData(form);
			const $form = $(form);
			const $submitButton = $form.find('button[type="submit"]');
			const $loader = $submitButton.find('.loader-1');

			fd.append('action', 'w4d_save_notify_email');
			fd.append('nonce', w4d_frontend_ajax.nonce);
			fd.append('product_id', this.variationId || this.productId);

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				data: fd,
				method: 'POST',
				processData: false,
				contentType: false,
				beforeSend: () => {
					$submitButton.prop('disabled', true);
					$loader.css('display', 'block');
				},
				success: (res) => {
					if (res.success) {
						if (this.dialog) {
							const $dialog = $(this.dialog);
							const $content = $dialog.find('.modal__content');

							if ($content.length) {
								$content.html(res.data.html);
							} else {
								this.dialog.innerHTML = res.data.html;
							}
							this.form = null;
						}
					} else {
						W4D_Toast.showToast('error', res.data.message || 'Došlo je do greške.');
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Greška pri slanju zahtjeva.');
				},
				complete: () => {
					$submitButton.prop('disabled', false);
					$loader.css('display', '');
				},
			});
		}
	}

	$(document).ready(() => {
		new W4D_AvailabilityNotify();
	});
})(jQuery);
